<template>
  <div>
    <v-row dense class="mx-1">
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text class="rounded-tag-small"
                      label="Busque por solicitante, empresa ou identificador"
                      v-model="searchText"
                      style="max-width: 400px"
                      :on-search="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange">
    </px-line-filter>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      statusOptions: [
        {
          id: 'TODAS',
          description: 'Todas',
          value: null,
        },
        {
          id: 'PENDENTES',
          description: 'Pendentes',
          value: ['PENDENTES'],
        },
        {
          id: 'APROVADAS',
          description: 'Aprovadas',
          value: ['APROVADAS'],
        },
        {
          id: 'RECUSADAS',
          description: 'Recusadas',
          value: ['RECUSADAS'],
        },
      ],
    };
  },
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia', 'hasRoleRequisicao']),
    selectedStatus: {
      get() {
        return this.$store.getters['listagemAprovacaoSolicitacao/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('listagemRelistagemAprovacaoSolicitacaoquisicao/selectedStatus', selectedStatus);
      },
    },
    searchText: {
      get() {
        return this.$store.getters['listagemAprovacaoSolicitacao/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemAprovacaoSolicitacao/searchText', searchText);
      },
    },
  },
  created() {
    if (!this.selectedStatus) {
      [this.selectedStatus] = this.statusOptions;
    }
  },
};
</script>
